module finadai.app.search {
  export var NAME = "finadai.app.search";
  function SearchController($scope, $state: ng.ui.IStateService){
    $scope.search = () => {
      $state.go('app.search.results', {q: $scope.query});
    }
  }
  export function run(){
    var search = angular.module(NAME, []);
    search.controller("SearchController", SearchController);
  }
}
finadai.app.search.run();